import styled from "styled-components";
import { generic, mobile } from "../../../../../ui/_themes/constants";
import { Icon } from "../../../../../ui/IconSVG";
import { SettingTextField } from "../../../../../ui/SettingTextField";
import { SettingToggle } from "../../../../../ui/SettingToggle";

export const GameSettingsWrapper = styled.div`
  margin: 0 auto;
  padding: 0 0 2em;
`;

export const GameSettingsTitle = styled.span`
  display: block;
  text-align: center;
  color: #ffffff;
  text-transform: uppercase;
  font-size: 1.3em;
  font-weight: 700;
  margin-bottom: 0.4em;
  letter-spacing: 0.03em;
`;

export const GameSettingsRow = styled.div`
  display: flex;
  align-items: center;
  padding: 0.75em 0;
`;

export const GameSettingsIconWrapper = styled.div`
  flex: 1em 0 0;
  padding-right: 2em;
`;

export const GameSettingsIcon = styled(Icon)`
  color: ${generic.gameSettings.icon.color};
  height: auto;

  @media (orientation: landscape) {
    width: 1.2em;
  }

  @media (orientation: portrait) {
    width: 1.4em;
  }
`;

export const GameSettingsLabel = styled<{ checked: boolean }, "span">("span")`
  flex: 1 1 auto;
  font-size: ${mobile.fontSize.s};
  letter-spacing: 0.06em;
  font-weight: 700;
  line-height: 1.5em;
  padding-right: 1em;
  color: ${({ checked }: any) =>
    checked
      ? generic.gameSettings.text.active
      : generic.gameSettings.text.color};
`;

export const SettingItemWrapper = styled.div`
  flex: 0 0 2em;
`;

export const StyledSettingToggle = styled(SettingToggle)`
  vertical-align: middle;
  display: inline-block;

  @media (orientation: landscape) {
    width: 2.2em;
  }

  @media (orientation: portrait) {
    width: 2.4em;
  }
`;

export const StyledSettingTextField = styled(SettingTextField)`
  width: 100%;
  vertical-align: middle;
  display: inline-block;
`;
